import { render, staticRenderFns } from "./Summit.vue?vue&type=template&id=92a1d23c&scoped=true&"
import script from "./Summit.vue?vue&type=script&lang=js&"
export * from "./Summit.vue?vue&type=script&lang=js&"
import style0 from "./Summit.vue?vue&type=style&index=0&id=92a1d23c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a1d23c",
  null
  
)

export default component.exports